/* eslint-disable indent */
import React from 'react';
import { useField } from 'formik';
import { AiFillCaretDown } from 'react-icons/ai';
import styles from './styles.module.scss';
import { HideDropdown } from '../../hooks/HideDropdown';

const SelectInput = (props) => {
  const { name, label = '', styling = {}, options = [] } = props;
  const [field] = useField(props);

  return (
    <fieldset className={styles.container}>
      <label htmlFor={name}>
        {label} {props.required ? <span className={styles.required}>*</span> : null}
      </label>
      <select style={styling} {...field} {...props}>
        {props.placeholder && (
          <option value="" disabled className={styles.placeholder}>
            {props.placeholder}
          </option>
        )}
        {options.length > 0
          ? options.map((_, i) => {
              return (
                <option
                  value={_.value}
                  data-amount={JSON.stringify(_.amount)} //value is an object
                  data-duration={_?.duration ?? ''}
                  key={`option-${i}`}
                >
                  {_.label}
                </option>
              );
            })
          : null}
      </select>
    </fieldset>
  );
};

export default SelectInput;

export const SelectInput2 = (props) => {
  const { name, label = '', options = [] } = props;

  return (
    <fieldset className={styles.container}>
      <label htmlFor={name}>
        {label} {props.required ? <span className={styles.required}>*</span> : null}
      </label>
      <select {...props}>
        {props.placeholder && (
          <option value="" disabled className={styles.placeholder}>
            {props.placeholder}
          </option>
        )}
        {options.length > 0
          ? options.map((_, i) => {
              return (
                <option
                  value={_.value}
                  data-amount={JSON.stringify(_.amount)} //value is an object
                  data-duration={_?.duration ?? ''}
                  key={`option-${i}`}
                >
                  {_.label}
                </option>
              );
            })
          : null}
      </select>
    </fieldset>
  );
};

export const CustomSelect = (props) => {
  const { label, inputRef, selectedItem, onChange, options = [] } = props;

  const { visible, setVisible, ref } = HideDropdown();

  const selectItem = (e) => {
    let selectedCurrency = e.target.innerText;
    onChange(selectedCurrency);
    setVisible('none');

    inputRef.current.focus();
  };
  const showDropdown = () => {
    setVisible('block');
  };

  return (
    <div className={styles.selectWrapper}>
      <p>{label}</p>
      <div className={styles.selectContainer}>
        <div onClick={showDropdown} className={styles.customSelect}>
          <p className={styles.selected}>{selectedItem}</p>
          <span className={styles.arrow}>
            <AiFillCaretDown />
          </span>
        </div>
        <ul ref={ref} style={{ display: visible }} className={styles.dropdown}>
          {options.map((_, i) => (
            <li onClick={selectItem} key={`option-${i}`}>
              {_.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
